"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Share = _interopRequireDefault(require("@insided/destination/icons/Share"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var TopicShare = function TopicShare(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return (0, _preact.h)(_Tooltip.default, {
    withArrow: true,
    trigger: (0, _preact.h)("div", {
      className: className
    }, (0, _preact.h)(_Share.default, {
      width: 16,
      height: 18
    }), (0, _preact.h)("span", {
      className: "post-footer-item-text"
    }, (0, _preact.h)(_phrase.default, {
      p: "Share"
    }))),
    tooltipMessage: (0, _preact.h)("ul", {
      className: ""
    }, "TBD")
  });
};

var _default = TopicShare;
exports.default = _default;